import React from 'react';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ClientInvoiceLineItemModify from '../../../../Domain/ClientInvoiceLineItemModify';
import ClientLineItemService from '../../../../Services/ClientLineItemService';

export default class EditMultipleAssignmentWindowDescription extends React.Component {
  static titleForCreate = '';
  static titleForEdit = 'Edit Multiple Records';
  static itemType = ClientInvoiceLineItemModify;
  static serviceFunction = (edited) => ClientLineItemService.EditMultipleLineItems(edited);

  getSelected() {
    return 'Items';
  }

  getSearchParameters() {
    return 'AllItemsInTheSearchSetAreSelected';
  }

  getAllItemInTheSearchAreSelected() {
    return 'SearchItem';
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'Client Billing',
      fields: [
        {
          fieldName: (item) => EditMultipleAssignmentWindowDescription.getClientCurrency(item),
          label: 'Currency',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AdHocGroupEnabled',
          label: 'Modify Ad-Hoc Invoice Group?',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AdHocGroup',
          label: 'Ad-Hoc Invoice Group',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.AdHocGroupEnabled !== true,
        },
        {
          fieldName: 'FieldworkFee',
          label: 'Fieldwork Fee',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableClientAmounts(item),
        },
        {
          fieldName: 'ClientFee',
          label: 'Client Fee',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableClientAmounts(item),
        },
        {
          fieldName: 'CcTravel',
          label: 'Travel',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableClientAmounts(item),
        },
        {
          fieldName: 'CcAdditionalFee',
          label: 'Additional Fee',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableClientAmounts(item),
        },
        {
          fieldName: 'CcMisc',
          label: 'Misc',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableClientAmounts(item),
        },
        {
          fieldName: 'CcReimbursement',
          label: 'Reimbursement',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableClientAmounts(item),
        },
        {
          fieldName: 'CcGaming',
          label: 'Gaming',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableClientAmounts(item),
        },
      ],
    },
    {
      label: 'Evaluator Payment',
      fields: [
        {
          fieldName: (item) => EditMultipleAssignmentWindowDescription.getEvaluatorCurrency(item),
          label: 'Currency',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'EvaluatorFee',
          label: 'Evaluator Fee',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableEvaluatorAmounts(item),
        },
        {
          fieldName: 'EvTravel',
          label: 'Travel',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableEvaluatorAmounts(item),
        },
        {
          fieldName: 'EvAdditionalFee',
          label: 'Additional Fee',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableEvaluatorAmounts(item),
        },
        {
          fieldName: 'EvMisc',
          label: 'Misc',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableEvaluatorAmounts(item),
        },
        {
          fieldName: 'EvReimbursement',
          label: 'Reimbursement',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableEvaluatorAmounts(item),
        },
        {
          fieldName: 'EvGaming',
          label: 'Gaming',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleAssignmentWindowDescription.disableEvaluatorAmounts(item),
        },
      ],
    },
  ];

  // The Currency row doubles as the explanation: when a page's fields are disabled it says why,
  // which is clearer than removing the page and leaving the user to guess where it went.
  static getClientCurrency(item) {
    if (item.Currencies && item.Currencies.length === 1) return item.Currencies[0];
    if (item.Currencies && item.Currencies.length > 1) {
      return `Mixed (${item.Currencies.join(', ')}) - select one currency to edit client amounts`;
    }
    return 'No client currency on the selected assignment(s) - client amounts cannot be edited';
  }

  static disableClientAmounts(item) {
    return !item.Currencies || item.Currencies.length !== 1;
  }

  // Amounts entered here are stored verbatim against the evaluator payment - they are never
  // converted - so they must be typed in the payment's own currency. When the selection spans
  // more than one currency (or none of the selected assignments has a payment yet) there is no
  // single currency to type in, so the amount fields are disabled. The backend re-checks this
  // across every affected assignment, because a select-all only exposes the current page here.
  static getEvaluatorCurrency(item) {
    if (item.EvCurrencyCode) return item.EvCurrencyCode;
    if (item.EvaluatorCurrencies && item.EvaluatorCurrencies.length > 1) {
      return `Mixed (${item.EvaluatorCurrencies.join(', ')}) - select one currency to edit evaluator amounts`;
    }
    return 'No evaluator payment on the selected assignment(s) - evaluator amounts cannot be edited';
  }

  static disableEvaluatorAmounts(item) {
    return !item.EvCurrencyCode;
  }
}
